export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_11-c043751c5ae9ce4b0becfc8a85f46673.jpg";